module.exports = __webpack_public_path__ + "static/media/error401.513ebc57.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/img/error/error401.png
// module id = 699
// module chunks = 8